<template>
    <div class="gift_block">

        <div class="categories">

        </div>

        <div class="form-group">
            <label class="form-label">{{ __t('PRODUCTS') }}</label>
            <v-select multiple
                      v-model="block.products"
                      :filterable="false"
                      label="title"
                      :options=products_search_options
                      @search="onSearch"
                      class="imc_reasons"
                      @input="emitUpdate">
                <template slot="option" slot-scope="option">
                    <div class="d-center">
                        {{ option.title }}
                        <div>
                            <small >{{option.uniq_id}}</small>

                            <small v-if="option.hasOwnProperty('prov_type')" >
                                {{option.prov_type}}
                            </small>
                        </div>
                    </div>
                </template>
            </v-select>
        </div>

        <div class="form-group d-flex align-items-center mt-2" v-if="!is_catalog">
            <yes_no
                key="IS_CHOICE"
                title="IS_CHOICE"
                @input="val => update('on_choice', val)"
                v-model="block.on_choice"
            >
            </yes_no>

        </div>

        <div class="form-group">
            <label class="form-label" v-if="is_catalog">{{ __t('DISCOUNT_PERCENT') }}</label>
            <label class="form-label" v-if="!is_catalog">{{ __t('MIN_ORDER_SUM') }}</label>

            <input type="number"
                   class="form-control"
                   :min="1"
                   :max="is_catalog ? 100 : 10000"
                   v-model="block.min_order"
                   @input="emitUpdate">
        </div>

        <button class="btn btn-danger btn-sm" @click="$emit('remove')">
            {{ __t('REMOVE') }}
        </button>
    </div>
</template>

<script>

import yes_no from "../../../../sys/radio/yes_no.vue";
import vSelect from 'vue-select';

export default {
    name: 'gift_block',
    components: {
        yes_no,
        vSelect
    },

    props: {
        block: {
            type: Object,
            required: true
        },

        is_catalog : {
            type : Boolean,
            default : false,
        }
    },
    data() {
        return {
            products_search: [],
        }
    },

    methods: {
        update(field, val) {
            this.block[field] = val;
            this.emitUpdate();
        },
        emitUpdate() {
            this.$emit('update', {...this.block});
        },

        onSearch(search, loading) {
            if (search.length > 2) {
                loading(true);
                this.search(loading, search);
            }
        },

        async search(loading, search) {
            this.products_search = [];
            await api.post('/internal/v1/catalog/products', {
                "filter": {
                    "search": search
                },
                "list": {
                    "limit": 100,
                }
            }).then(({data}) => {
                loading(false);
                if (data.status === "operation_success") {
                    this.products_search = data.data;
                }
            }).catch(({response}) => {
                loading(false);
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                })
            });
        },
    },

    computed: {
        products_search_options () {
            return this.products_search.map(item => {
                return {
                    "id" : item.id,
                    "title" : item.title,
                    'uniq_id' : item.uniq_id,
                    'prov_type' : item.prov_type
                }
            });
        }
    },
}
</script>

<style scoped>
.gift_block {
    border: 1px solid #ddd;
    padding: 16px;
    margin-top: 16px;
    border-radius: 6px;
    background-color: #f9f9f9;
}
</style>
